<template>
  <ClientFilter :id="id" v-model="modelValue.ownerNaturalIds" />
</template>

<script lang="ts" setup>
import { toRefs } from 'vue';

import { ShipmentSearchCriteria } from '@/model';

import ClientFilter from '@/components/search/ClientFilter.vue';

const modelValue = defineModel({
  type: ShipmentSearchCriteria,
  default: () => new ShipmentSearchCriteria(),
});

const props = defineProps({
  id: {
    type: String,
    required: true,
  },
});

const { id } = toRefs(props);
</script>
